import React, { Component, useContext, useEffect, useState } from "react"

import { Tooltip as MateriaUiTooltip, makeStyles, MenuItem, Select } from "@material-ui/core"
import { Modal, ModalHeader, ModalBody } from "reactstrap"
import { CommunityProjectContext } from "./context"
import { useUserOrgs } from "../../../hooks/use-user"
import { useAuth0 } from "@auth0/auth0-react"
import _ from "lodash"
import JoinProjectForm from "./joinProjectForm"
import { fetch_delete, fetch_get, fetch_patch, fetch_post, fetch_put } from "../../../utils/fetch"
import { BsPeopleFill } from "react-icons/bs"
import * as Sentry from "@sentry/gatsby"

function CommunityProjectContainer(props) {
  let contextData = useContext(CommunityProjectContext)

  const project = props.project
  const {
    currentOrg: {
      role: { isSuperAdmin },
    },
  } = useUserOrgs()
  const { isAuthenticated, user } = useAuth0()
  const { getAccessTokenSilently } = useAuth0()
  var [openModal, setopenModal] = React.useState(false)
  const useStyles = makeStyles(() => ({
    modal: {
      width: 500,
    },
  }))
  const classes = useStyles()
  var [loadStatus, setLoadStatus] = useState({
    loading: false,
    contributtor: false,
    error: false,
    errorMessage: null,
  })

  // console.log(user)
  // useEffect(() => {
  //   if (_.isNil(props.projectId)) return
  //   contextData.setProjectId(props.projectId)
  //   contextData.setParentProps(props.parentProps)
  // }, [props.projectId, props.parentProps])

  // useEffect(() => {
  //   if (_.isNil(contextData.editingItem)) return
  //   setopenModal(true)
  // }, [contextData.editingItem])

  // useEffect(() => {
  //   if (!openModal) contextData.setEditingItem(null)
  // }, [openModal])

  const checkIfUserIsAContributor = () => {
    var usernanme = user["https://api.codelinaro.org/username"]
    setLoadStatus({ loading: true, contributtor: false, error: false, errorMessage: null })
    getAccessTokenSilently()
      .then(accessToken =>
        fetch_get(`users/project/${props.project.projectId}/check/if/contributor`, accessToken)
          .then(response => {
            if (response.status.code === 201) {
              setLoadStatus({
                loading: false,
                contributtor: response.data === undefined ? false : response.data,
                error: false,
                errorMessage: null,
              })
              // contextData.setSuccessData(response.data)
            }
          })
          .catch(error => {
            setLoadStatus({
              loading: false,
              contributtor: false,
              error: true,
              errorMessage: `${error}`,
            })
            Sentry.captureException(error)
            console.log(`Error while adding project link to workgroup: ${error}`)
          })
      )
      .catch(error => {
        setLoadStatus({
          loading: false,
          contributtor: false,
          error: true,
          errorMessage: `${error}`,
        })
        Sentry.captureException(error)
        console.log(`Error while getting access token: ${error}`)
      })
  }

  useEffect(() => {
    if (isAuthenticated) {
      checkIfUserIsAContributor()
    }
  }, [isAuthenticated])

  return (
    <React.Fragment>
      {!isSuperAdmin && (
        <>
          {project.externalContribution === true && project.status === "active" && (
            <>
              {isAuthenticated ? (
                <>
                  {loadStatus.loading && !loadStatus.error && (
                    <>
                      <div className="spinner-grow spinner-grow-sm" role="status"></div>...
                    </>
                  )}
                  {!loadStatus.loading && !loadStatus.error && (
                    <>
                      {(loadStatus.contributtor || contextData.isNowContributor) && (
                        <>
                          <BsPeopleFill size={25} /> Contributing
                        </>
                      )}
                      {!(loadStatus.contributtor || contextData.isNowContributor) && (
                        <>
                          <button
                            type="button"
                            className="btn btn-light btn-sm"
                            onClick={() => setopenModal(true)}
                          >
                            <strong>Join This Project</strong>
                          </button>
                        </>
                      )}
                    </>
                  )}
                  {!loadStatus.loading && loadStatus.error && (
                    <div className="alert alert-danger py-1" role="alert">
                      {loadStatus.errorMessage}
                    </div>
                  )}
                </>
              ) : (
                <>
                  <a
                    type="button"
                    className="btn btn-light btn-sm border-success"
                    // onClick={() => goToJoinForm()}
                    href={`../projects/${props.project.parentOrganization}/${props.project.projectSlug}/contributor/join`}
                  >
                    <strong>Join This Project</strong>
                  </a>
                </>
              )}

              <Modal
                isOpen={openModal}
                toggle={() => setopenModal(!openModal)}
                backdrop="static"
                zIndex={1}
                size="xl"
                centered={true}
                className={classes.modal}
                style={{ maxWidth: "500px", width: "100%" }}
              >
                <ModalHeader toggle={() => setopenModal(!openModal)}>
                  Join as a contributor
                </ModalHeader>
                <ModalBody>
                  {/* <ProjectAddEdit /> */}
                  <JoinProjectForm {...props} />
                </ModalBody>
              </Modal>
            </>
          )}
        </>
      )}
    </React.Fragment>
  )
}

export default CommunityProjectContainer
